var map = {
	"./RBW.png": 558,
	"./background.png": 394,
	"./banner.png": 1242,
	"./copper.png": 1243,
	"./discord.png": 391,
	"./gitBook.png": 1244,
	"./grass.png": 390,
	"./logo.png": 1245,
	"./object.png": 247,
	"./telegram.png": 1246,
	"./title.png": 393,
	"./twitter.png": 392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1241;